import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'submenu', 'button' ]

  toggle(event){
    if(this.submenuTarget.getAttribute('aria-hidden') === 'true') {
      this.show(event)
    } else {
      this.hide(event)
    }
  }

  show(event){
    this.submenuTarget.classList.remove('lg:hidden')
    this.submenuTarget.classList.add('lg:block')
    this.submenuTarget.setAttribute('aria-hidden', 'false')

    this.buttonTarget.classList.add('border-green-500')
    this.buttonTarget.classList.remove('border-white')
  }

  hide(event){
    this.submenuTarget.classList.add('lg:hidden')
    this.submenuTarget.classList.remove('lg:block')
    this.submenuTarget.setAttribute('aria-hidden', 'true')

    this.buttonTarget.classList.add('border-white')
    this.buttonTarget.classList.remove('border-green-500')
  }
}
